<template>
  <div>

    <main role="main">

      <div class="container">

        <div class="row mb-5">

          <div class="col-md-12">

            <h2 class="mb-3">
              <i class="fa fa-search"></i> {{ $t('text.documentLists.izrocenoGradivo.title') }}
            </h2>


            <div class="form-condensed">

              <div class="row">
                <div class="col-md-6">

                  <div class="form-group">
                    <label :for="'povezanSistem'">{{ $t('text.classificationPlanMetadata.connectedSystem') }}</label>

                    <v-select :options="options_povezan_sistem"
                              :reduce="item => item.id"
                              id="povezanSistem"
                              label="description"
                              class="form-control"
                              v-model="filterFields.oznaka_povezanega_sistema"
                    >
                      <span slot="no-options">{{ $t('text.globals.noOptions') }}</span>
                    </v-select>

                  </div>

                </div>

                <div class="col-md-6">

                  <div class="form-group">
                    <label :for="'vpisnik'">{{ $t('text.classificationPlanMetadata.registry') }}</label>

                    <v-select :options="options_vpisnik"
                              :reduce="item => item.id"
                              id="vpisnik"
                              label="description"
                              class="form-control"
                              v-model="filterFields.oznaka_vpisnika"
                    >
                      <span slot="no-options">{{ $t('text.globals.noOptions') }}</span>
                    </v-select>

                  </div>

                </div>
              </div>


              <div class="row">
                <div class="col-md-6">

                  <div class="form-group">
                    <label :for="'sodisce'">{{ $t('text.globals.court') }}</label>

                    <v-select :options="options_sodisce"
                              :reduce="item => item.id"
                              id="sodisce"
                              label="description"
                              class="form-control"
                              v-model="filterFields.sodisce"
                    >
                      <span slot="no-options">{{ $t('text.globals.noOptions') }}</span>
                    </v-select>

                  </div>

                </div>

                <div class="col-md-6">

                  <div class="form-group">
                    <label :for="'opravilna_stevilka_zadeve'">{{ $t('text.globals.caseNumber') }}</label>

                    <input type="text" class="form-control" id="opravilna_stevilka_zadeve"
                           v-model.trim="filterFields.opravilna_stevilka_zadeve"
                           :placeholder="$t('text.globals.enterValue')"
                    >

                  </div>

                </div>
              </div>

              <div class="row">

                <div class="col-md-6">

                  <div class="form-group">
                    <label
                        :for="'klasifikacijska_oznaka_razreda'">{{ $t('text.documentLists.classificationLabel') }}</label>

                    <ClassificationClassDropdown :placeholder="$t('text.globals.enterValue')"
                                                 :id="'klasifikacijska_oznaka_razreda'"
                                                 :value="filterFields.klasifikacijska_oznaka_razreda"
                                                 @knSelected="(val) => { filterFields.klasifikacijska_oznaka_razreda = val;  } "></ClassificationClassDropdown>


                  </div>

                </div>

                <div class="col-md-6">

                  <div class="form-group">
                    <label :for="'rok_hrambe'">{{ $t('text.classificationPlanMetadata.expiration') }}</label>

                    <v-select :options="options_rok_hrambe"
                              :reduce="item => item.id"
                              id="rok_hrambe"
                              label="explanation"
                              class="form-control"
                              v-model="filterFields.rok_hrambe"
                    >
                      <span slot="no-options">{{ $t('text.globals.noOptions') }}</span>
                    </v-select>

                  </div>

                </div>
              </div>

              <div class="row">
                <div class="col-md-6">

                  <div class="form-group">
                    <label
                        :for="'datum_zadnje_spremembe_statusa_gradiva'">{{ $t('text.documentLists.lastStatusChangeDate') }}</label>

                    <VueCtkDateTimePicker :id="'datum_zadnje_spremembe_statusa_gradiva'" format="YYYY-MM-DD"
                                          :label="$t('text.globals.selectDate')"
                                          :locale="$t('text.globals.datePickerLocale')"
                                          :noLabel="true"
                                          :custom-shortcuts="customShortcuts"
                                          :range="true"
                                          :auto-close="true"
                                          formatted="DD.MM.YYYY"
                                          v-model="filterFields.datum_zadnje_spremembe_statusa_gradiva"
                                          :only-date="true"
                                          :button-now-translation="$t('text.globals.now')"
                    />
                  </div>
                </div>
              </div>


            </div>

            <a class="btn btn-primary text-white mt-5" @click="submitQuery(true)" id="buttonSearchQuery"><i
                class="fa fa-search"></i> {{ $t('text.globals.search') }}</a>

            <a class="btn btn-primary text-white mt-5" @click="clearSearch()" id="buttonClearFilters">
              {{ $t('text.globals.clearAllFilters') }}</a>

          </div>
        </div>

        <div>

          <loading :active.sync="isLoading"
                   :can-cancel="false"
                   :is-full-page="false"></loading>

          <div class="row" v-if="queryResult.length > 0">
            <div class="col-md-12">
              <div class="bg-light p-4">
                <a class="btn btn-primary text-white" @click="generateReport()"
                   v-if="$globalFunctions.checkForPermission('POROCILO_IZVOZ')">
                  {{ $t('text.documentLists.makeDocumentAccessionReport') }}</a>
              </div>
            </div>
          </div>

          <SearchResults
              :appSection="'IZROCENO_GRADIVO'"
              :queryResult="queryResult"
              :filtersQuery="filtersQuery"
              :columns="columns"
              :context="context"
              :totalRecords="totalRecords"
              :serverParams="serverParams"
          ></SearchResults>

        </div>
      </div>
    </main>

  </div>
</template>

<script type="text/javascript">
import Vue from 'vue';
import SearchResults from '../components/SearchResults';
import axios from 'axios';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import DetailedSearchFieldAndValue from '../components/DetailedSearchFieldAndValue';
import swal from "sweetalert2";
import ClassificationClassDropdown from '@/components/ClassificationClassDropdown'

export default {
  name: 'DocumentSearchFullText',
  components: {
    ClassificationClassDropdown,
    SearchResults,
    vSelect,
    Loading
  },

  data() {
    return {
      filtersQuery: [],
      context: {},
      sites: [],
      user: {},
      error: '',
      filterFields: {
        oznaka_povezanega_sistema: '',
        oznaka_vpisnika: '',
        sodisce: '',
        opravilna_stevilka_zadeve: '',
        klasifikacijska_oznaka_razreda: '',
        rok_hrambe: '',
        datum_zadnje_spremembe_statusa_gradiva: ''
      },

      options_povezan_sistem: [],
      options_vpisnik_all: [],
      options_vpisnik: [],
      options_sodisce: [],
      options_rok_hrambe: [],

      selectedDocuments: [],
      selectedDocumentsList: [],

      isLoading: false,
      totalRecords: null,
      serverParams: {
        columnFilters: {},
        sort: [],
        page: 1,
        perPage: this.$store.getters.getItemsPerPage
      },
      queryResult: [],
      searchableFields: [
        {
          id: 'EH:klasifikacijska_oznaka_razreda',
          description: this.$t('text.documentLists.classificationLabel'),
        }
      ],
      columns: _.cloneDeep(this.$globalFunctions.getListColumns('izrocenoGradivo')),
      allMetadataOptions: [],
      metadataSearchValues: {},
      customShortcuts: this.$t('text.globals.customDatePickerShortcuts'),
      aftsQuery: null
    };
  },

  watch: {
    'filterFields.oznaka_povezanega_sistema': function (val, oldVal) {
      const _this = this;
      if (val) {
        _this.options_vpisnik = _.filter(_this.options_vpisnik_all, {connectedSystem: val});
      } else {
        _this.options_vpisnik = _this.options_vpisnik_all;
        _this.filterVpisnikiOptions();
      }
    },
  },


  mounted() {
    const _this = this;

    let p1 = _this.$store.dispatch("retrieveAllMetadataOptions");
    let p2 = _this.$store.dispatch("retrieveAllDropdownOptions");
    let p3 = _this.$store.dispatch("retrieveReportTypeOptions");

    Promise.all([p1, p2, p3]).then((values) => {
      _this.allMetadataOptions = _this.$store.getters.getAllMetadataOptions;
      _this.metadataSearchValues = _this.$store.getters.getMetadataSearchValues;

      _.each(_this.allMetadataOptions, function (val, key) {
        let property = val.property;

        if (property === 'EH:oznaka_povezanega_sistema') {
          _this.options_povezan_sistem = _.filter(val.body, {ehramba: true});
        } else if (property === 'EH:oznaka_vpisnika') {
          _this.options_vpisnik = val.body;
          _this.options_vpisnik_all = val.body;
        } else if (property === 'EH:sodisce') {
          _this.options_sodisce = val.body;
        } else if (property === 'EH:rok_hrambe') {
          _this.options_rok_hrambe = val.body;
        }
      });

      if (_this.$route.query.queryParams != null) {
        let documentsListFiltersObject = JSON.parse(atob(_this.$route.query.queryParams));
        _this.filterFields = documentsListFiltersObject;
        _this.submitQuery(true);
      }

      _this.filterVpisnikiOptions();

    });

  },
  computed: {
    getRokHrambe() {
      return this.$store.getters.getStorageDateOptions
    }


  },
  methods: {

    clearSearch() {

      // query fields
      this.filterFields = {
        oznaka_povezanega_sistema: '',
        oznaka_vpisnika: '',
        sodisce: '',
        opravilna_stevilka_zadeve: '',
        klasifikacijska_oznaka_razreda: '',
        rok_hrambe: '',
        datum_zadnje_spremembe_statusa_gradiva: ''
      };

      this.selectedDocuments = [];
      this.$store.dispatch("setSelectedDocuments", []);

      this.filtersQuery = [];
      this.totalRecords = null;
      this.serverParams = {
        columnFilters: {},
        sort: [],
        page: 1,
        perPage: this.$store.getters.getItemsPerPage
      };
      this.queryResult = [];
      this.context = {};
      this.isLoading = false;
      this.query = '';

      this.columns = _.cloneDeep(this.$globalFunctions.getListColumns('izrocenoGradivo'));

      // url change
      this.$router.replace({
        name: 'IzrocenoGradivo',
      }).catch(err => {
      });

    },

    filterVpisnikiOptions() {
      const _this = this;
      let filteredVpisniki = [];

      _.forEach(_this.options_povezan_sistem, function (value, key) {
        let items = _.filter(_this.options_vpisnik, {connectedSystem: value.id});

        _.each(items, function (_val, _key) {
          filteredVpisniki.push(_val);
        });
      });
      _this.options_vpisnik = filteredVpisniki;
    },

    clearFiltersQuery() {
      this.filtersQuery = [];
    },

    onOperatorChange(index) {
      if (index == 1) {
        if (this.filterOneOperator == null) {
          this.fieldsAndValues[1] = {
            filterField: null,
            filterValue: null,
          };
        }
      } else {
        if (this.filterTwoOperator == null) {
          this.fieldsAndValues[2] = {
            filterField: null,
            filterValue: null,
          };
        }
      }


    },

    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },

    onPageChange(params) {
      const _this = this;

      _this.isLoading = true;

      console.log("onPageChange", params);

      _this.updateParams({page: params});
      setTimeout(function () {
        _this.submitQuery();
      }, 1)

    },

    onPerPageChange() {
      const _this = this;
      _this.updateParams({perPage: _this.$store.getters.getItemsPerPage});
      setTimeout(function () {
        _this.submitQuery(true);
      }, 1)
    },

    onSortChange(params) {
      const _this = this;

      _this.isLoading = true;

      let sort = [];

      _.map(_this.columns, function (item, i) {

        console.log(item);

        if (item.sort && typeof (item.sort.ascending) !== 'undefined') {

          let sortItem = {
            'ascending': item.sort.ascending ? 'true' : 'false',
            'field': _this.$globalFunctions.formatFieldNameForSort(item.field),
            'type': 'FIELD'
          };

          sort.push(sortItem);

        }
      });

      _this.updateParams({
        sort: sort,
      });

      setTimeout(function () {
        _this.submitQuery();
      }, 1);


    },

    onColumnFilter(params) {
      const _this = this;
      _this.updateParams(params);
      setTimeout(function () {
        _this.submitQuery();
      }, 1)
    },


    submitQuery(newSearch) {
      let _this = this;

      _this.isLoading = true;
      _this.queryResult = [];
      _this.showSolrDelayWarning = false;
      _this.selectedDocuments = [];

      let queryFromFields = "";

      _.forOwn(_this.filterFields, function (value, key) {
        console.log("value", value);
        console.log("key", key);
        if (value != '' && value != null) {
          if (key === 'datum_zadnje_spremembe_statusa_gradiva') {
            //queryFromFields += 'EH:' + key + ':[' + value.start + ' TO ' + value.end + '] AND '
            queryFromFields += 'EH:' + key + ':[\'' + _this.moment(value.start, 'YYYY-MM-DD').startOf('day').utc().format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z\' TO \'' + _this.moment(value.end, 'YYYY-MM-DD').endOf('day').utc().format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z\'] AND '
          } else if (key === 'opravilna_stevilka_zadeve') {
            queryFromFields += '(EH:' + key + ': \"' + value + '\") AND '
          } else {
            queryFromFields += '(EH:' + key + ':' + value + ') AND '
          }
        }
      });

      // remove last ' AND '
      queryFromFields = queryFromFields.substr(0, queryFromFields.length - 5);

      queryFromFields = queryFromFields === '' ? '*' : queryFromFields
      queryFromFields = queryFromFields + ' AND EH:izroceno:true AND NOT ASPECT:"rma:ghosted"'

      console.log("queryFromFields", queryFromFields);


      let query = {
        "query": {
          "language": "afts",
          "query": "PATH:\"/app:company_home/st:sites/cm:rm/cm:documentLibrary//*\" AND ((ASPECT:\"rma:record\" AND ASPECT:\"rma:declaredRecord\") AND NOT ASPECT:\"rma:frozen\" AND " + queryFromFields + " AND NOT ASPECT:\"rma:versionedRecord\")"
        },
        "defaults": {
          "namespace": "http://www.alfresco.org/model/recordsmanagement/1.0",
        },
        "paging": {
          "maxItems": _this.serverParams.perPage,
          "skipCount": newSearch ? 0 : (_this.serverParams.page - 1) * _this.serverParams.perPage
        },
        "include": [
          "properties"
        ],
        "sort": this.$globalFunctions.reformatSortArray(_this.serverParams.sort),
        "templates": [
          {
            "template": "%(cm:creator)",
            "name": "creator"
          },
          {
            "template": "%(cm:name cm:title cm:description TEXT)",
            "name": "keywords"
          },
          {
            "template": "%(rmc:supplementalMarkingList)",
            "name": "markings"
          },
          {
            "template": "%(cm:created)",
            "name": "created"
          },
          {
            "template": "%(cm:author)",
            "name": "author"
          },
          {
            "template": "%(cm:modifier)",
            "name": "modifier"
          },
          {
            "template": "%(cm:description)",
            "name": "description"
          },
          {
            "template": "%(rma:recordSearchDispositionActionAsOf)",
            "name": "dispositionActionAsOf"
          },
          {
            "template": "%(cm:title)",
            "name": "title"
          },
          {
            "template": "%(rma:recordSearchDispositionInstructions)",
            "name": "dispositionInstructions"
          },
          {
            "template": "%(rma:recordSearchDispositionEventsEligible)",
            "name": "dispositionEventsEligible"
          },
          {
            "template": "%(rma:recordSearchVitalRecordReviewPeriod)",
            "name": "vitalRecordReviewPeriod"
          },
          {
            "template": "%(rma:recordSearchHasDispositionSchedule)",
            "name": "hasDispositionSchedule"
          },
          {
            "template": "%(rma:recordSearchDispositionEvents)",
            "name": "dispositionEvents"
          },
          {
            "template": "%(cm:name)",
            "name": "name"
          },
          {
            "template": "%(cm:modified)",
            "name": "modified"
          },
          {
            "template": "%(rma:recordSearchDispositionAuthority)",
            "name": "dispositionAuthority"
          },
          {
            "template": "ISNODE:T",
            "name": "KEY_REPLACELONESTAR"
          },
          {
            "template": "%(rma:recordSearchDispositionActionName)",
            "name": "dispositionActionName"
          },
          {
            "template": "%(rma:recordSearchDispositionPeriod)",
            "name": "dispositionPeriod"
          }
        ],
        "facetQueries": [
          {"query": "content.size:[0 TO 102400]", "label": "0MB - 0.1MB"},
          {"query": "content.size:[102400 TO 1048576]", "label": "0.1MB do 1MB"},
          {"query": "content.size:[1048576 TO 10485760]", "label": "1MB do 10MB"},
          {"query": "content.size:[10485760 TO 10485760000000]", "label": "nad 10MB"}
        ],
        "facetFields": {
          "facets": [
            {"field": "content.mimetype", "label": "mimetype"},
            {"field": "EH:klasifikacijska_oznaka_razreda", "label": "klasifikacijskaOznakaRazreda"},
            {"field": "EH:sodisce", "label": "sodišče"},
            {"field": "EH:opravilna_stevilka_zadeve", "label": "opravilnaŠtevikaZadeve"},
            {"field": "EH:fizicno_gradivo", "label": "fizičnoGradivo"},
            {"field": "EH:oznaka_povezanega_sistema", "label": "oznakaPovezanegaSistema"},
            {"field": "EH:oznaka_vpisnika", "label": "oznakaVpisnika"},
            {"field": "EH:rok_hrambe", "label": "rokHrambe"},
          ]
        }
      };

      let filterQueryString = '';

      _.map(_this.filtersQuery, function (val) {
        filterQueryString += ' AND ' + val;
      });

      query.query.query = query.query.query + filterQueryString; // + ' AND TYPE:cm:content' + ' AND -EXISTS:EH:komponenta_povezave_na_dokumente';

      _this.aftsQuery = query.query.query;

      axios.post(config.alfrescoSearchApi, query)
          .then((res) => {
            _this.totalRecords = res.data.list.pagination.totalItems;
            _this.serverParams.page = res.data.list.pagination.skipCount / _this.serverParams.perPage + 1;
            _this.queryResult = res.data.list.entries;
            _this.context = res.data.list.context;
            _this.isLoading = false;

            _this.$router.replace({
              name: 'IzrocenoGradivo',
              query: {queryParams: btoa(JSON.stringify(_this.filterFields))}
            }).catch(err => {
            });

            setTimeout(function () {
              document.documentElement.scrollTop = _this.$store.getters.getOffsetTop;
              _this.$store.dispatch("setOffsetTop", null);
            }, 1);


          })
          .catch((error) => {
            console.log("error", error);
          });


    },

    onRowClick(row) {
      let _this = this;

      console.log(row);

      let id = row.id;

      if (row.isFile) {
        _this.$router.push("/dokument/" + id);
      } else {
        Vue.$toast.open({
          message: this.$t('text.documentLists.openingIsEnabledJustForFilesToast'),
          type: 'error',
          position: 'top-right'
        });
      }

    },

    onCheckboxClick($event, uuid) {
      let _this = this;

      $event.stopPropagation();

      if (_this.selectedDocuments.indexOf(uuid) > -1) {
        _this.selectedDocuments.splice(_this.selectedDocuments.indexOf(uuid), 1);
      } else {
        _this.selectedDocuments.push(uuid);
      }

      _this.generateSelectedDocumentList();
      _this.$store.dispatch("setSelectedDocuments", _this.selectedDocuments);

      console.log(_this.selectedDocuments);

      console.log("uuid", uuid);

      // let id = row.id;
      //
      // if (row.isFile) {
      //     _this.$router.push("/dokument/" + id);
      // } else {
      //     Vue.$toast.open({
      //         message: 'Odpiranje je omogočeno samo za datoteke.',
      //         type: 'error',
      //         position: 'top-right'
      //     });
      // }

    },

    generateSelectedDocumentList() {
      const _this = this;
      _this.selectedDocumentsList = [];

      _.map(_this.selectedDocuments, function (val) {
        _.map(_this.queryResult, function (_val) {
          if (_val.entry.id === val) {
            _this.selectedDocumentsList.push(_val.entry);
          }
        });
      });
    },

    onThCheckboxClick($event) {
      let _this = this;
      $event.stopPropagation();

      const checkboxItem = $event.target.id === "selectAllTh" ? $event.target.querySelector("#selectAllCheckbox") : $event.target;

      if (checkboxItem.checked) {
        console.log("select all documents!");
        _.map(_this.queryResult, function (val) {
          if (_this.selectedDocuments.indexOf(val.entry.id) === -1) {
            _this.selectedDocuments.push(val.entry.id);
          }
        });
      } else {
        console.log("DEselect all documents!");
        _this.selectedDocuments = [];
      }

      _this.generateSelectedDocumentList();

      _this.$store.dispatch("setSelectedDocuments", _this.selectedDocuments);
    },

    generateReport() {
      const _this = this;

      let data = {
        "reportType": "IZVOZ",
        "query":
            {
              "aftsQuery": _this.aftsQuery,
              "explanationList": []
            }
      }

      _.forOwn(_this.filterFields, function (value, key) {
        if (value != '' && value != null) {
          data.query.explanationList.push({
            parameter: 'EH:' + key,
            value: value
          });
        }
      });

      if (data.query && data.query.explanationList) {
        _.map(data.query.explanationList, function (val, key) {

          let _val = val;


          let _value = val.value.replace(/['"]+/g, '');
          //
          // console.log("_value", _value);
          // console.log("_parameter", val.parameter);
          // console.log("typeof _value", typeof _value);



          if (_value && _value !== '' && typeof val.value === 'string' && val.value.indexOf('{') === -1) {
            if (_value === "true") {
              _value = 'DA';
              _val.value = _value;
            } else if (_value === "false") {
              _value = 'NE';
              _val.value = _value;
            } else {
              _val.value = _this.$globalFunctions.getReadableCodeListValueFromProperty(_this.allMetadataOptions, val.parameter, _value);
            }
          } else if (_val.value.indexOf('{') !== -1) {

            console.log("DATE", _value);

            let startDate = /start:(.+?)(,|})/g.exec(_value)[1].split("-");
            let endDate = /end:(.+?)(,|})/g.exec(_value)[1].split("-");

            console.log("STARTDATE", startDate);
            console.log("ENDDATE", endDate);
            _val.value = `Od: ${startDate[2]}.${startDate[1]}.${startDate[0]}, do: ${endDate[2]}.${endDate[1]}.${endDate[0]}`
          }
          else {
            if (_value != '') {
              _val.value = _this.$globalFunctions.getReadableCodeListValueFromProperty(_this.allMetadataOptions, val.parameter, _value);
            } else {
              _val.value = _value;
            }
          }

          console.log("_val.value", _val.value);

          let _parameter = _.filter(_this.$t('text.documentSearch.documentSearchDetailed.searchableFields'), {id: val.parameter});
          if (_parameter.length > 0) {
            _val.parameter = _parameter[0].description;
          }
        });

        if(data.query.explanationList.length === 0) {
          data.query.explanationList = [{operator: '', parameter: '', value: '-'}];
        }

      }

      _this.$globalFunctions.generateReport(data, {dontWaitForResponse: false});
    },

    unselectAll() {
      const _this = this;

      _this.selectedDocuments = [];
      _this.selectedDocumentsList = [];
      _this.$store.dispatch("setSelectedDocuments", []);
      _this.$refs.searchResultsWithSelection.checkIfHeaderCheckboxShouldBeChecked();
    },

    selectAll() {
      const _this = this;

      _.map(_this.queryResult, function (val) {
        if(_this.selectedDocuments.indexOf(val.entry.id) === -1) {
          _this.selectedDocuments.push(val.entry.id);
        }
      });

      _this.$store.dispatch("setSelectedDocuments", _this.selectedDocuments);
    }

  }
};
</script>



// WEBPACK FOOTER //
// src/pages/IzrocenoGradivo.vue